import {useEffect} from 'react';

import {Meticulous} from '../../services/meticulous/Meticulous';
import {recordRumFeatureFlagEvaluation} from './datadogRumFlagEval';

/**
 * Records a feature flag value to telemetry.
 * This is the single point of truth for feature flag telemetry, so we can log the same
 * flag and value to multiple telemetry systems.
 *
 * @param key - the feature flag key
 * @param value - the feature flag value
 */
export function recordFeatureFlag(key: string, value: boolean | undefined) {
  // log value to datadog RUM
  recordRumFeatureFlagEvaluation(key, value ?? false);
  // log value to Meticulous
  Meticulous.recordFeatureFlag(key, value ?? false);
}

/**
 * Records a feature flag value to telemetry.
 * This is the single point of truth for feature flag telemetry, so we can log the same
 * flag and value to multiple telemetry systems.
 *
 * @param key - the feature flag key
 * @param value - the feature flag value
 */
export function useRecordFeatureFlag(key: string, value: boolean | undefined) {
  useEffect(() => {
    recordFeatureFlag(key, value);
  }, [key, value]);
}
